import { Component } from '@angular/core';
import { NavBreadcrumb } from '@models/models';
import {
	Template,
	TEMPLATE_MOCK_DATA
} from '@web-components/settings/settings.model';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { DeleteItemModalComponent } from '@web-components/settings/common/delete-item-modal/delete-item-modal';

@Component({
	selector: 'contact-form-section',
	template: require('./contact-form-section.html'),
	styles: [require('./contact-form-section.scss')]
})
export class ContactFormSectionComponent {
	templates: Array<Template> = TEMPLATE_MOCK_DATA;
	breadcrumbs: Array<NavBreadcrumb> = [
		{ link: '/', title: 'Dashboard' },
		{ link: '/settings', title: 'Settings' },
		{ link: null, title: 'Contact Form' }
	];

	private deleteModalRef: NgbModalRef;

	constructor(private snModalService: SNModalService) {}

	addNewTemplate(): void {}

	editTemplate(template: Template): void {}

	duplicateTemplate(template: Template): void {}

	deleteTemplate(template: Template): void {
		this.deleteModalRef = this.snModalService.openModal(
			DeleteItemModalComponent
		);

		this.deleteModalRef.componentInstance.btnDisabled = false;
		this.deleteModalRef.componentInstance.itemName = template.title;
		this.deleteModalRef.componentInstance.modalTitle = 'Contact Form';
		this.deleteModalRef.componentInstance.modalData = template;

		this.snModalService.getModalData().subscribe((data: Template) => {
			this.deleteModalRef.close();
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/settings/contact-form-section/contact-form-section.ts